import { Component, effect, inject, Signal } from '@angular/core';
import { NgClass } from '@angular/common';
import { Toast, TOAST_NOTIFICATIONS_TIMEOUT, ToastNotificationsService } from '../../core/services/toast-notifications.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-toast-message',
    templateUrl: './toast-message.component.html',
    styleUrls: ['./toast-message.component.scss'],
    imports: [NgClass],
    standalone: true
})
export class ToastMessageComponent {

  toastService = inject(ToastNotificationsService);
  toast: Signal<Toast | null | undefined> = toSignal(this.toastService.toast$);
  isVisible = false;

  constructor() {
    effect(() => {
      const toastValue = this.toast();
      setTimeout(() => {
        this.isVisible = !!toastValue;
        setTimeout(() => {
          this.isVisible = false;
        }, TOAST_NOTIFICATIONS_TIMEOUT - 200);
      }, 100);
    });
  }
}
